import React from 'react';

export default props => (
  <div className="card rounded-0 options">
    <div className="card-body p-2">
      <span className="title">Options</span>
      {props.children}
    </div>
  </div>
);
